import { Table as TanstackTable } from '@tanstack/react-table'
import { flexRender } from '@tanstack/react-table'
import { Column as ColumnLayout, Row } from 'src/shared/components/Semantic/all'
import { Alert, AlertDescription } from 'src/shared/components/ui/alert'
import { AlertCircle } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/shared/components/ui/table'
import { TeamMember } from '../types'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const TeamMembersTable = ({
  table,
  onEditUser,
  onRemoveUser,
}: {
  table: TanstackTable<TeamMember>
  onEditUser: (user: TeamMember) => void
  onRemoveUser: (orgUserId: number) => Promise<void>
}) => {
  const { t } = useLocalization()

  return (
    <ColumnLayout className="w-full">
      <div className="border rounded-lg bg-white h-[calc(100vh-350px)] overflow-y-auto relative">
        <Table>
          <TableHeader className="sticky top-0 z-10">
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  return (
                    <TableHead key={header.id}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </TableHead>
                  )
                })}
              </TableRow>
            ))}
          </TableHeader>

          <TableBody>
            {table.getRowModel().rows?.length ? (
              table.getRowModel().rows.map((row) => (
                <TableRow
                  key={row.id}
                  data-state={row.getIsSelected() && 'selected'}
                >
                  {row.getVisibleCells().map((cell) => (
                    <TableCell key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={table.getAllColumns().length}
                  className="h-24"
                >
                  <Alert variant="default" className="mt-4 w-fit mx-auto">
                    <Row className="gap-2 items-center">
                      <AlertCircle className="h-4 w-4" />
                      <AlertDescription>
                        {t(
                          'Invite users to your organization to get started',
                          'Bjud in användare till din organisation för att komma igång'
                        )}
                      </AlertDescription>
                    </Row>
                  </Alert>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </ColumnLayout>
  )
}
